<template>
  <div id="modalOrderRemark" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-md"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("order.订单备注") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25 model-auto-h">
          <div class="row mg-b-30">
            <div class="col-6">
              <span>{{ $t("order.订单号：") }}</span>
              <span class="tx-info">{{ item.code }}</span>
            </div>
            <div class="col-6">
              <span>{{ $t("order.供应商") }}：</span>
              <span class="tx-info">{{ item.rawSupplier || "---" }}</span>
            </div>
          </div>
          <div
            v-if="(item.orderRemark || []).length > 0"
            class="row bg-gray-100 pd-y-10 mg-b-15 follow-list"
          >
            <h4 class="col-12 tx-14 tx-gray-600 mg-b-10">
              {{ $t("distributor.历史备注") }}
            </h4>
            <ul class="col-12">
              <li
                v-for="(remark, index) in item.orderRemark"
                :key="index"
                class="row mg-b-10"
              >
                <span class="col-12">{{ remark }}</span>
              </li>
            </ul>
          </div>
          <div class="form-group row">
            <label
              for="iptFollow"
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("order.备注：") }}</label
            >
            <div class="col-md-10 col-sm-12">
              <textarea
                rows="3"
                name="remark"
                id="iptFollow"
                class="form-control form-control-sm"
                v-model="remarkText"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex">
          <div>
            <button
              type="button"
              class="
                mg-r-5
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="save()"
            >
              {{ $t("order.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
              aria-label="Close"
            >
              {{ $t("order.关闭") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      remarkText: "",
    };
  },
  filters: {
    rTime(time) {
      moment.locale("zh-cn");
      return moment(time, "YYYY-MM-DD h:mm:ss").fromNow();
    },
  },
  mounted() {
    $("#modalOrderRemark").on("hidden.bs.modal", (e) => {
      this.remarkText = "";
    });
    $("#modalOrderRemark")
      .off("hide.bs.modal")
      .on("hide.bs.modal", () => {
        $("#modalOrderRemark .follow-list").scrollTop(0);
      });
  },
  methods: {
    save() {
      if (!this.remarkText) {
        ShowTip(this.$t("distributor.备注内容不能为空"), "danger");
        return;
      }
      this.$parent.loading = true;
      $.api_call(
        "api.SupplierPurchaseOrder.addRemark",
        {
          code: this.item.code,
          orderRemark: this.remarkText,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.添加成功"), "success");
            $("#modalOrderRemark").modal("hide");
            setTimeout(() => {
              this.$parent.getRMOrder(true);
            }, 500);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.follow-list {
  max-height: 350px;
  overflow-y: scroll;
}
.ckbox :disabled + span {
  opacity: 0.4;
}
</style>